import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { signUp } from '../../store/actions/authActions'

class SignUp extends Component {

  state = {
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    address:'',
    city:'',
    state:'',
    zip:'',
    location:''
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

 preventSubmit = (e) =>{
    e.preventDefault();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if(this.state.state !== '' && this.state.zip !== '' && this.state.city !== '' && this.state.address !== '' 
    && this.state.email !== '' && this.state.password !== '' && this.state.firstName !== '' && this.state.lastName !== ''){
      this.props.signUp(this.state, (userId)=>{
        //console.log('user ID');
        //console.log(userId);
      });
    }
    else{
      alert('Please complete the form before submitting.')
    }
  }

  handleDefaultAddress = (e) => {
    e.preventDefault();
    this.setState({
        address: "1100 W Main st",
        city: "Richmond",
        state: "VA",
        zip: "23220",
        location: [37.546801,-77.450286]
    });
  }

  submitInterruptor =(e)=>{
    document.getElementById("myModal").style.display = "block";

    if(this.state.state !== '' && this.state.zip !== '' && this.state.city !== '' && this.state.address !== '' ){
      
      var newAddress = this.state.address;
      var newState = this.state.state;
      var newCity = this.state.city;
      var newZip = this.state.zip;

      var itemArray = [newAddress, newState, newCity, newZip];
      var shouldTest = [true,true,true,true];
      var falseTest = [false,false,false,false];

      while(JSON.stringify(shouldTest) != JSON.stringify(falseTest)){
        for(var item in itemArray){
          if(shouldTest[item]){ 
            if(itemArray[item].charAt(itemArray[item].length-1)=='.' ||
              itemArray[item].charAt(itemArray[item].length-1)==' ' ||
              itemArray[item].charAt(itemArray[item].length-1)==','
              ){
              itemArray[item] = itemArray[item].slice(0,-1);
            }
            else{
              shouldTest[item] = false;
            }
          }
        }  
      }

      this.calculateLocation(itemArray[1], itemArray[3], itemArray[2], itemArray[0]);
      //console.log('location');
      //console.log(this.state.location);
    }

  }

  closeFunction =(e)=>{document.getElementById("myModal").style.display = "none";}

  calculateLocation = (state, zip, city, address) => {

    const Http = new XMLHttpRequest();
    const addressEncoded = encodeURIComponent(address);

    const url='https://dev.virtualearth.net/REST/v1/Locations/US/'+state+'/'+zip+'/'+city+'/'+addressEncoded+'?&key=AkkmVqZTTAl0pdIReyon_6fwQ9WkzPuTxhYYqAAjV08oE2_jX_OqCj1Dbytnlh_O';
    //console.log('url');
    //console.log(url);

    Http.open("GET", url);
    Http.send();
    const that = this;

    Http.onreadystatechange=function(){
      if(this.readyState === 4 && this.status === 200 && that.state.httpResponse !== Http.responseText){
        var parsedJSON = JSON.parse(Http.responseText);
        //console.log(parsedJSON);
        that.setState({httpResponse:parsedJSON})
        if(that.state.httpResponse !== ''){
          //console.log('coordinates');
          //console.log(that.state.httpResponse.resourceSets[0].resources[0].geocodePoints[0].coordinates);
          that.setState({location: that.state.httpResponse.resourceSets[0].resources[0].geocodePoints[0].coordinates});
          that.setState({route:''});
        }
      }
      else{console.log('notready')}
    }
  }

  render() {
    const { auth, authError } = this.props;
    if (auth.uid) return <Redirect to='/' /> 
    return (
      <div className="signInContainer" style={{"paddingBottom":"10px"}}>
        <div id="myModal" className="modal2">
          <div className="modal-content2">
            <span className="close2" onClick={this.closeFunction}>&times;</span>
            
            { !this.state.location &&
              <div>
                <p>The address form has not been acceptably filled.</p>
                <p>Make sure all fields have values and remove any symbols</p>
                <button className="btn pink lighten-1" onClick={this.handleDefaultAddress}>USE DEFAULT ADDRESS</button>
              </div>
            }

            { this.state.location &&
              <div>
              <p>Are you sure you want to submit?</p>
              <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                <button className="btn pink lighten-1" onClick={this.handleSubmit}>Submit</button>
              </div>
              </div>  
            }

          </div>
        </div>

        <form className="formContainer" onSubmit={this.preventSubmit} style={{"borderRadius":"20px", "padding":"10px"}} >
          <h5 className="grey-text text-darken-3" style={{"display":"flex", "justifyContent":"center"}}>Sign Up</h5>
          <div className="input-field">
            <label className="active" htmlFor="email">Email</label>
            <input type="email" id='email' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label className="active" htmlFor="password">Password</label>
            <input type="password" id='password' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label className="active" htmlFor="firstName">First Name</label>
            <input style={{color: "black"}} type="text" id='firstName' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label className="active" htmlFor="lastName">Last Name</label>
            <input style={{color: "black"}} type="text" id='lastName' onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <input style={{color: "black"}} type="text" id='address' value={this.state.address} name='address' onChange={this.handleChange} />
            <label className="active" htmlFor="title">Address</label>
          </div>
          <div className="input-field">
            <label className="active" htmlFor="city">City</label>
            <input style={{color: "black"}} type="text" id='city' value={this.state.city} onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label className="active" htmlFor="state">State</label>
            <input style={{color: "black"}} type="text" id='state' value={this.state.state} onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <label className="active" htmlFor="zip">Zip</label>
            <input style={{color: "black"}} type="text" id='zip' value={this.state.zip} onChange={this.handleChange} />
          </div>
          <div className="input-field" style={{"display":"flex", "justifyContent":"center"}}>
            <button className="btn pink lighten-1 z-depth-0" onClick={this.submitInterruptor}>Sign Up</button>
            <div className="center red-text">
              { authError ? <p>{authError}</p> : null }
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    authError: state.auth.authError
  }
}

const mapDispatchToProps = (dispatch)=> {
  return {
    signUp: (creds, callback) => dispatch(signUp(creds, callback))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp)
